<template>
    <div>
        <footer class="footer">
            <div class="container-fluid">
                <div class="copyright ml-auto">
                    2019, made with <i class="fa fa-heart heart text-danger"></i> by <a href="">Diskominfo-Sandi Kab. Konsel</a>
                </div>				
            </div>
        </footer>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
